import * as constants from "../constants";

export interface UpdateAuthAction {
    type: constants.UPDATE_AUTH;
    data: { isAuthed: boolean };
}

export function updateAuth(isAuthed: boolean): UpdateAuthAction {
    return {
        data: { isAuthed },
        type: constants.UPDATE_AUTH,
    };
}
